import { UPDATE_GAME } from '../constants/action-types'
import store from '../store'

export default function game(state = INITIAL.game, action) {
  let gameId
  let gameData

  if (action.payload) {
    gameId = action.payload.id
    gameData = action.payload
  }

  switch (action.type) {
    case UPDATE_GAME:
      return {
        ...state,
        user_id: gameData.user_id,
      }
    case 'SET_GAME':
      return action.game
    case 'REGENERATE_VIEWER_TOKEN':
      // Make API call to regenerate token
      fetch(`/games/${action.gameId}/regenerate_viewer_token`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        },
      })
      .then(response => response.json())
      .then(data => {
        store.dispatch({ type: 'SET_GAME', game: data })
      });

      return {
        ...state,
        private_token: null, // This will be updated by the server response
      }
    default:
      return state
  }
}
